/**
 * @file dashboard-href.ts
 * @description Сборщик адресов отфильтрованных реестров для дашборда склада
 * (phase19.24 этап 1, шаг 3; склад в ссылках — правка по ревью 2026-09-20).
 *
 * Плитка и строка «Требует внимания» обязаны вести в реестр С ТЕМ ЖЕ отбором,
 * который человек видел на сводке: выбрал склад «Основной», нажал «Без места»
 * — и в остатках должен стоять тот же склад, иначе счётчик «2» открывает
 * список из сорока партий соседнего склада.
 *
 * Сборщик один на оба реестра, чтобы правило «склад едет в ссылку» не
 * разъехалось между двумя файлами. Пустые значения выбрасываются: `?wh=` в
 * адресе значит «склад не выбран» и только удлиняет ссылку.
 */

/** Адрес внутри раздела склада: база (`/shop/:slug/wms`) + путь + параметры. */
export function wmsHref(
  base: string,
  path: string,
  params: Record<string, string | undefined> = {},
): string {
  const query = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value) query.set(key, value);
  }
  const qs = query.toString();
  return `${base}${path}${qs ? `?${qs}` : ""}`;
}
